import React from 'react'
import IconButton from '@mui/material/IconButton'
import { ArrowLeft } from '@phosphor-icons/react'

// Encabezado de una página o listado con título, subtítulo y acciones opcionales.
// Recibe las props del componente padre como atributos y las extrae del objeto recibido.
// title: título principal del encabezado.
// subtitle: subtítulo opcional; se muestra cuando tiene contenido.
// children: contenido entre las etiquetas de AppListHeader, como botones de acción.
// onBack: función que se ejecuta al pulsar volver; si no se pasa, el botón no aparece.
// backLabel: texto accesible del botón de volver; por defecto es "Volver".
//
// Uso básico: <AppListHeader title="Liquidaciones" />
// Uso con subtítulo, botón de volver y una acción:
// <AppListHeader
//   title="Liquidaciones"
//   subtitle="Consulta y administra las liquidaciones"
//   onBack={() => navigate(-1)}
//   backLabel="Volver al listado"
// >
//   <button onClick={crearLiquidacion}>Nueva liquidación</button>
// </AppListHeader>
export default function AppListHeader({ title, subtitle, children, onBack, backLabel = 'Volver' }) {
  const heading = (
    <div className="app-page-heading">
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
    </div>
  )

  return (
    <div className="index-header detailed-container index-header--action-bar">
      {onBack ? (
        <div className="app-page-heading-group">
          <IconButton className="app-page-back" onClick={onBack} aria-label={backLabel}>
            <ArrowLeft size={22} aria-hidden="true" />
          </IconButton>
          {heading}
        </div>
      ) : (
        heading
      )}
      {children}
    </div>
  )
}
